module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexServices"
    }
  }, [_c('section', {
    staticClass: "sub--header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tServis Kami\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "nav-target",
    attrs: {
      "id": "navigation-type-service"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-list-nav"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#bussinessprocess"
    }
  }, [_vm._v("Bussines Proces")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#company-profile"
    }
  }, [_vm._v("Company Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#ecommerce"
    }
  }, [_vm._v("E-Commerce")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#sisteminformasi"
    }
  }, [_vm._v("Sistem Informasi")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#buildstartup"
    }
  }, [_vm._v("Build Start Up")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#webapplication"
    }
  }, [_vm._v("Web App")])]), _vm._v(" "), _c('li', {
    staticClass: "tech"
  }, [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#technologies"
    }
  }, [_vm._v("Technologies")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper service-page-wrapper bg-white",
    attrs: {
      "id": "bussinessprocess"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPROCESS BUSSINES/AGILE PROJECT MANAGEMENT\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe necessitatibus temporibus sint, soluta, repellat eum suscipit dolorum numquam sunt reiciendis perferendis dolores velit ad voluptas architecto accusamus, placeat eveniet ipsam?\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "service-wrapper__image-process"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/agile.png",
      "alt": ""
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "company-profile"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCompany Profile\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/company-profile.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-white",
    attrs: {
      "id": "ecommerce"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/ecommerce.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tE-Commerce\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "sisteminformasi"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tSistem Informasi\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet lorem")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/sisteminformasi.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-white",
    attrs: {
      "id": "buildstartup"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/startup.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tBuild Start Up\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "webapplication"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tWeb App\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/webapp.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper",
    attrs: {
      "id": "technologies"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tTechnologies Use\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet totam officia facilis inventore asperiores illo animi nisi iusto maiores similique, explicabo sint a. Minus, labore, hic exercitationem at ab ea!\n\t\t\t\t\t\t\t")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b4c91cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/services/IndexServices.vue
// module id = 67
// module chunks = 0